module.exports = __webpack_public_path__ + "static/media/test_turtle.ee0278ec.jpg";